import { Form, Select } from "antd";
import { IntelligenceFormFieldsEnum } from "../../enum";
import { OperatorEnum } from "@src/pages/intelligence-search/enum";
import { QuestionDependencySelector } from "./question-dependencies-selector";
import { useQueryDependenciesGraphContext } from "../../context/questions-context";

export const QuestionDependenciesWrapper: React.FC<{
    name: number;
    fieldKey?: number;
    queryKey: string;
}> = ({ name, fieldKey, queryKey }) => {
    const { getQueryDef, getDependableQueries, isFirstQuestion, metaDictionary } = useQueryDependenciesGraphContext();
    const { jsonQuery } = getQueryDef(queryKey);
    const dependableQueries = getDependableQueries(queryKey);

    const isEmptyDependableQueries = dependableQueries === undefined || Object.keys(dependableQueries).length === 0;
    const isHidden =
        isFirstQuestion(queryKey) ||
        isEmptyDependableQueries ||
        jsonQuery === undefined ||
        metaDictionary === undefined;

    const form = Form.useFormInstance();
    const queryDependenciesTypeWatch = Form.useWatch(
        [IntelligenceFormFieldsEnum.QUESTIONS, name, IntelligenceFormFieldsEnum.QUERY_DEPENDENCIES_TYPE],
        form,
    );
    return (
        <div className={`${isHidden ? "hidden" : "flex flex-wrap items-start"}  `}>
            <Form.Item
                className="mr-2"
                fieldKey={fieldKey}
                name={[name, IntelligenceFormFieldsEnum.QUERY_DEPENDENCIES_TYPE]}
            >
                <Select
                    placeholder="Link to question (optional)"
                    style={{ width: "220px" }}
                    allowClear
                    options={[
                        { label: "In Segment", value: OperatorEnum.BELONG },
                        { label: "Not In Segment", value: OperatorEnum.NOT_BELONG },
                    ]}
                    onChange={(value) => {
                        if (value) return;
                        form.setFieldValue(
                            [IntelligenceFormFieldsEnum.QUESTIONS, name, IntelligenceFormFieldsEnum.QUERY_DEPENDENCIES],
                            {},
                        );
                    }}
                />
            </Form.Item>
            <Form.Item
                className="w-[400px]"
                fieldKey={fieldKey}
                name={[name, IntelligenceFormFieldsEnum.QUERY_DEPENDENCIES]}
                rules={[
                    {
                        validator: (_, value) => {
                            if (!queryDependenciesTypeWatch) {
                                return Promise.resolve();
                            }
                            if (Object.keys(value || {}).length === 0) {
                                return Promise.reject(new Error("Please select at least one question"));
                            }
                            return Promise.resolve();
                        },
                    },
                ]}
            >
                <QuestionDependencySelector disabled={!queryDependenciesTypeWatch} queryKey={queryKey} />
            </Form.Item>
        </div>
    );
};
